import React from 'react';
import './TrustSection.css';

const TrustSection = () => {
    return (
        <section className="trust-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="trust-circle">
                            <div className="trust-content">
                                <h2>It All Comes Down To Trust</h2>
                                <p>What can we add to the trust we hold between employees and clients? Between industries and needs? We are committed to creating connections with care, with understanding.</p>
                            </div>
                            <div className="rotating-dots"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustSection;